<template>
  <div
    v-if="
      (isCurrentPlan && isFundamentals && !showPlanId) ||
        isPremium ||
        showPlanId === plan.merchant_id
    "
    :class="[
      'plan',
      isPlanSelected && 'plan__selected',
      isMonthly && 'plan__monthly',
      isAnnual && 'plan__annual',
      isCurrentPlan && 'plan__current-plan',
      isFundamentals && 'plan__fundamentals',
      isPremium && 'plan__premium',
      isPromotion && 'plan__promotion',
    ]"
    @click="handleUpdatePlan(plan)"
  >
    <div v-if="isCurrentPlan && !isPromotion" class="plan__current-plan-label">
      <div class="plan__current-plan-label__text">
        Your plan
      </div>
      <div class="plan__current-plan-label__ribbon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="9"
          viewBox="0 0 10 9"
          fill="none"
        >
          <path d="M9.03125 8.75L0 0H9.03125V8.75Z" fill="#4529B4" />
        </svg>
      </div>
    </div>
    <div
      class="plan__header-info"
      :class="isPremium && 'plan__header-info--best-value'"
    >
      <div v-if="isMonthly || isAnnual" class="plan__header-info-content">
        Limited Introductory Content
        <NotificationIcon
          v-tooltip="{
            content:
              'Over 200 hours of novice-level <br> content across 7 learning paths',
            placement: 'top-center',
            classes: ['tooltip__text-centered'],
          }"
          class="plan__header-info-icon"
        />
      </div>
      <div v-if="isPremium" class="plan__header-info-content">
        Entire Content Library
        <NotificationIcon
          v-tooltip="{
            content:
              'Access 3500+ hours of content across 50+ learning paths <br>for all skill levels; Skill Dive not included',
            placement: 'top-center',
            classes: ['tooltip__text-centered'],
          }"
          class="plan__header-info-icon"
        />
      </div>
    </div>
    <div
      :class="[
        'plan__container',
        (isMonthlyPlanDisabled || isCurrentPlan) &&
          'plan__container--unselectable',
        isPremium && 'plan__container__premium',
      ]"
    >
      <div
        v-if="!isCurrentPlan"
        :class="[
          'plan__radio-button',
          isPlanSelected && 'plan__radio-button--selected',
        ]"
      ></div>
      <div class="plan__name-wrapper">
        <div
          v-if="isFundamentals"
          :class="[isFundamentals && 'plan__fundamentals-training-offer']"
        >
          200+ Training Hours
        </div>
        <div
          v-if="isPremium"
          :class="[isPremium && 'plan__premium-training-offer']"
        >
          3500+ Training Hours
        </div>
        <p class="plan__name">{{ cleanName(plan.name) }}</p>
        <div v-if="isMonthly && isCurrentPlan" class="plan__change-fund-plan">
          <span @click="changePlanVisibility(annualPlanId)"
            >Show annual pricing</span
          >
        </div>
        <div v-if="!isCurrentPlan || isPromotion" class="plan__price-container">
          <div
            v-if="isPromotion"
            class="plan__price plan__price-promotion plan__price--crossed"
          >
            <Crosses3 class="plan__price-crosses" />
            {{ cleanPrice(plan.price) }}
          </div>
          <p class="plan__price">
            {{ isPromotion ? `$${promotionPrice}` : cleanPrice(plan.price) }}
          </p>
          <p class="plan__term">/{{ planTerm(plan) }}</p>
        </div>
      </div>
      <div
        :class="[
          'plan__divisorline',
          (isAnnual || isPremium) && 'plan__divisorline--hasbadge',
        ]"
      ></div>
      <div class="plan__details-container">
        <p
          v-for="detail in plan.details"
          :key="`detail-${detail.name}`"
          :class="[
            'plan__detail',
            detail.greenCheck && 'plan__detail--green-check',
          ]"
        >
          <CheckIcon
            v-if="detail.checked"
            class="plan__flair plan__flair--checked"
          />
          <XIcon v-else class="plan__flair plan__flair--unchecked" />
          <span
            :class="[
              'plan__flair-info',
              !detail.checked && 'plan__flair-info--unchecked',
            ]"
            >{{ detail.name }}</span
          >
        </p>
      </div>
      <div v-if="moreInfoUrl" class="plan__details-learn-more-wrapper">
        <a
          :href="moreInfoUrl"
          class="plan__details-learn-more-link"
          target="_blank"
        >
          See What's Included
          <ExternalLinkIcon class="plan__details-learn-more-icon" />
        </a>
      </div>
    </div>
    <div v-if="isAnnual || isPremium" class="plan__floating-badges">
      <div class="plan__floating-badges-text">{{ floatingBadgeText }}</div>
      <div
        v-if="isAnnual"
        class="plan__floating-badges-icons plan__floating-badges-fundamental"
      >
        <img
          src="@/assets/icons/certifications/badges/ejpt.png"
          alt="eJPT Certification"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
        >
          <path
            d="M0.719727 5.29192H5.40223V0.435059H7.86802V5.29192H12.5505V7.65808H7.86802V12.5647H5.40223V7.65808H0.719727V5.29192Z"
            fill="white"
          />
        </svg>
        <img
          src="@/assets/icons/certifications/badges/icca.png"
          alt="ICCA Certification"
        />
      </div>
      <div
        v-if="isPremium"
        class="plan__floating-badges-icons  plan__floating-badges-premium"
      >
        <FullscreenIcon />
      </div>
    </div>
    <div v-if="isPremium" class="plan__fake-footer-premium"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import { CheckIcon, XIcon, ExternalLinkIcon } from 'vue-feather-icons'
import FullscreenIcon from '@/assets/icons/certifications/badges/badge-premium.svg'
import Crosses3 from '@/assets/images/subscriptions/banners/crosses3.svg'
import NotificationIcon from '@/assets/icons/notification.svg'

export default {
  name: 'Plan',
  components: {
    CheckIcon,
    XIcon,
    ExternalLinkIcon,
    FullscreenIcon,
    Crosses3: { name: 'Crosses3', ...Crosses3 },
    NotificationIcon: { name: 'NotificationIcon', ...NotificationIcon },
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    hasMonthlyPlan: {
      type: Boolean,
      required: true,
    },
    selectedPlan: {
      type: Object,
      required: false,
    },
    moreInfoUrl: {
      type: String,
      required: false,
    },
    isPromotion: {
      type: Boolean,
      required: false,
      default: false,
    },
    promotionContent: {
      type: Object,
      required: false,
    },
    showPlanId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      annualPlanId: CONSTANTS.PLANS.ALL.fundamentals_annual,
      monthlyPlanId: CONSTANTS.PLANS.ALL.fundamentals_monthly,
    }
  },
  computed: {
    ...mapState({
      premiumPlanCode: state => state.subscriptions.premiumPlanCode,
    }),
    ...mapGetters({
      usersSubscriptions: 'subscriptions/usersSubscriptions',
      activePlans: 'subscriptions/activePlans',
    }),
    isPremiumPlusPlan() {
      return (
        this.plan?.merchant_id ===
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE
      )
    },
    isMonthly() {
      return this.plan?.merchant_id === CONSTANTS.PLANS.ALL.fundamentals_monthly
    },
    isAnnual() {
      return this.plan?.merchant_id === CONSTANTS.PLANS.ALL.fundamentals_annual
    },
    isFundamentals() {
      return this.isAnnual || this.isMonthly
    },
    isPremium() {
      return this.plan?.merchant_id === CONSTANTS.PLANS.ALL.ine_premium
    },
    isCurrentMonthlyPlan() {
      return (
        this.plan?.merchant_id === CONSTANTS.PLANS.MONTHLY &&
        this.hasMonthlyPlan
      )
    },
    isMonthlyPlanDisabled() {
      const {
        hasMonthlyPlan,
        plan: { merchant_id },
      } = this
      return (
        !hasMonthlyPlan &&
        merchant_id === CONSTANTS.PLANS.MONTHLY &&
        merchant_id !== this.currentPlan
      )
    },
    isPlanSelected() {
      return this.selectedPlan?.name === this.plan.name
    },
    isCurrentPlan() {
      const {
        plan: { merchant_id },
      } = this
      return this.currentPlan === merchant_id
    },
    currentPlan() {
      const filteredPlans = this.activePlans.filter(
        plan => plan.plan_code !== CONSTANTS.PLANS.ALL.skill_dive_annual
      )
      return filteredPlans && filteredPlans.length
        ? filteredPlans[0]?.plan_code
        : null
    },
    floatingBadgeText() {
      if (this.isAnnual) return 'eJPT & ICCA Vouchers'
      if (this.isPremium) return 'Annual Voucher Discount'
      return ''
    },
    promotionPrice() {
      return this.promotionContent?.price_usd
    },
  },
  methods: {
    cleanName(name) {
      if (name === 'Premium Defense Bundle') return 'Premium+'
      return name.replace('Individual', '')
    },
    cleanPrice(price) {
      const priceParts = price.split('.')
      return priceParts[1] === '00' ? priceParts[0] : price
    },
    planTerm(plan) {
      return [
        CONSTANTS.PLANS.ALL.premium_monthly,
        CONSTANTS.PLANS.ALL.fundamentals_monthly,
      ].includes(plan.merchant_id)
        ? 'month'
        : plan.term
    },
    handleUpdatePlan(plan) {
      if (this.isCurrentPlan || this.isMonthlyPlanDisabled) return
      this.$emit('update-selected-plan', plan)
    },
    changePlanVisibility(planId) {
      this.$emit('change-plan-visibility', planId)
    },
  },
}
</script>

<style lang="scss">
.plan {
  $this: &;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  margin-bottom: 10px;
  background: var(--glass-mid-gray);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  &__premium {
    border-left: 10px solid #863ad2;
    border-right: 10px solid #5936e4;
    box-sizing: border-box;
  }
  @include mobile {
    width: 50%;
  }
  @include tablet {
    width: 530px;
  }
  &__promotion {
    @include mobile {
      width: 100%;
    }
  }
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: var(--white);
    background: var(
      --glass-mid-gray,
      linear-gradient(
        105deg,
        rgba(62, 63, 73, 0.7) -13.91%,
        rgba(62, 63, 73, 0) 100.48%
      )
    );
    position: relative;
    transition: 0.5s;
    padding: 40px 20px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    flex: 1 0 25%;
    gap: 30px;
    border-radius: 0 0 10px 10px;

    &:hover:not(.plan__container--unselectable) {
      background: var(--glass-extra-light);
    }
    &:active:not(.plan__container--unselectable) {
      background: var(--glass-dark);
    }
    &__premium {
      background: var(--glass-mid-gray);
    }
    @include tablet {
      padding: 40px 30px;
    }
  }
  &__header-info {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background: var(--glass-extra-light);
    &-content {
      font-size: rem(14px);
      line-height: 14px;
      color: var(--white);
      text-align: center;
      &--purple {
        color: var(--purple-pale);
      }
      display: flex;
    }
    &-icon {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
    &--best-value {
      background: var(--purple-gradient);
    }
  }
  &__fundamentals {
    #{$this}__header-info {
      border-radius: 10px 10px 0 0;
    }
  }
  &__fake-footer-premium {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 10px;
    width: 100%;
    background: var(--purple-gradient);
  }
  &__current-plan-label {
    position: absolute;
    left: -9px;
    top: 34px;
    width: 87px;
    height: 32.75px;
    z-index: 1;
    &__text {
      color: var(--white);
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 14px; /* 116.667% */
      text-transform: uppercase;
      display: inline-flex;
      padding: 5px 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: linear-gradient(90deg, #863ad2 3.58%, #5936e4 97.14%);
    }
    &__ribbon {
      fill: #4529b4;
      width: 9.031px;
      height: 8.75px;
      flex-shrink: 0;
      display: grid;
    }
  }
  &__divisorline {
    width: 470px;
    height: 1px;
    background: linear-gradient(
      112deg,
      rgba(187, 188, 199, 0.4) -46.39%,
      rgba(187, 188, 199, 0) 112.38%
    );
    &--hasbadge {
      width: 149px;
      @include tablet {
        width: 312px;
      }
    }
  }
  &__radio-button {
    position: absolute;
    top: 20px;
    right: 30px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: solid 1px var(--athens-gray);
    &--selected {
      background: rgba(0, 218, 153, 0.1);
      border: 1px solid var(--positive-light);

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--athens-gray);
      }
    }
  }
  &__current-plan {
    cursor: default;
  }
  &__name {
    font-size: rem(24px);
    line-height: 32px;
    margin: 0;
    width: 100%;
    text-transform: capitalize;
    font-family: var(--font-bold);
    text-align: left;
    &-wrapper {
      display: flex;
      height: 119px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
  }
  &__fundamentals-training-offer {
    color: var(--performance-light);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  &__premium-training-offer {
    color: var(--ice-cold);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
  }
  &__change-fund-plan {
    color: var(--purple-pale);
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  &__price-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
  }
  &__details {
    &-container {
      display: flex;
      flex-direction: column;
    }
    &-learn-more {
      &-link {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: var(--purple-pale);
        font-feature-settings: 'clig' off, 'liga' off;

        font-family: var(--font-book);
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 450;
        line-height: 1.25rem;
      }
      &-icon {
        height: 20px;
        margin-left: 3px;
      }
    }
  }
  &__price {
    margin: 0;
    font-family: var(--font-bold);
    font-size: rem(54);
    line-height: 66px;
    &-promotion {
      font-family: var(--font-book);
      font-size: rem(54px);
      font-style: normal;
      font-weight: 450;
    }
    &-crosses {
      position: absolute;
      left: 2.362px;
      bottom: 8.593px;
    }
  }
  &__term {
    color: var(--athens-gray);
    font-size: rem(12px);
    margin: 0 0 0 5px;
  }
  &__detail {
    padding: 0;
    margin: 0 0 4px 0;
    display: flex;
    width: 100%;
    text-align: start;
    font-size: rem(14px);
    line-height: 20px;
    &:nth-child(-n + 4) {
      width: 120px;
    }
    @include tablet {
      &:nth-child(-n + 4) {
        width: 100%;
      }
    }
    &--green-check {
      color: var(--ice-cold);
    }
  }
  &__flair {
    min-width: 14px;
    width: 14px;
    margin-right: 8px;
    &--checked {
      color: var(--positive-light);
    }
    &--unchecked {
      color: var(--perfect-gray);
    }
    &-info {
      margin-top: 2px;
      &--unchecked {
        color: var(--perfect-gray);
      }
    }
  }
  &__btn {
    color: var(--white);
    border-color: var(--orange);
    &--unselected {
      --btn-secondary-text-color: var(--lighter-gray);
      --btn-border-color: var(--lighter-gray);
    }
    @include mobile {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &__floating-badges {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 26px;
    position: absolute;
    right: 20px;
    top: 212px;
    &-icons {
      display: flex;
      height: 81px;
      justify-content: center;
      align-items: center;
      gap: -3px;
      align-self: stretch;
      img {
        width: 77.95px;
        height: 92px;
      }
    }
    &-text {
      color: var(--white);
      text-align: center;
      font-size: rem(14px);
      font-style: normal;
      font-weight: 450;
      line-height: 20px; /* 142.857% */
    }
    @include tablet {
      right: 30.5px;
      top: 212px;
    }
  }
}
</style>
